// extracted by mini-css-extract-plugin
export default {"main-application-section":"Application_main-application-section__XP3bi","application-area":"Application_application-area__dRqye","side-bar":"Application_side-bar__Cro2H"};